export enum PopupDismissedReasons
{
    Keyboard = 'Keyboard',
    // Mouse = 'Mouse',
}

export enum PopupDismissedKeys
{
    ESC = 'ESC',
}

export class PopupDismissedKey
{
    constructor(public key:PopupDismissedKeys)
    {
    }

    public static key(popupDismissedKey:PopupDismissedKeys):PopupDismissedKey
    {
        return new PopupDismissedKey(popupDismissedKey);
    }
}

export class PopupDismissedReason
{
    constructor(
        public reason:PopupDismissedReasons,
        public data?:PopupDismissedKey)
    {
    }

    public static keyboard(popupDismissedKey:PopupDismissedKeys):PopupDismissedReason
    {
        return new PopupDismissedReason(
            PopupDismissedReasons.Keyboard,
            PopupDismissedKey.key(popupDismissedKey)
        );
    }
}
